import { render, staticRenderFns } from "./CertificationsTable.vue?vue&type=template&id=10db4354&"
import script from "./CertificationsTable.vue?vue&type=script&lang=js&"
export * from "./CertificationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports